import { Checkbox } from "./ui/Checkbox";
import { cn } from "../../utils/cn";
import { ToggleRefinementProps, useToggleRefinement } from "react-instantsearch";

export type RefinementToggleProps = {
    className: string,
    children: any,
} & ToggleRefinementProps;

export default function RefinementToggle({ className, children, attribute, on }: RefinementToggleProps) {
    const { value, canRefine, refine } = useToggleRefinement({ attribute, on })

    return (
        <label className={cn(
            !canRefine && "tw-cursor-not-allowed tw-opacity-50",
            className
        )}>
            {children}

            <Checkbox
                checked={value.isRefined}
                disabled={!canRefine}
                onCheckedChange={() => refine(value.onFacetValue)}
                className={cn(
                    "tw-h-4 tw-w-4 tw-border-black tw-text-white tw-mr-2",
                    !canRefine && "tw-cursor-not-allowed",
                )}
            />
        </label>
    )
}